import React from "react";
import { MenuItemLink } from "./menu-item-link";
import { SubMenu } from "./submenu";

export const MenuItem = ({ item }) => {
    return (
        <li data-testid="menu-item">
            <MenuItemLink {...item} />
            {item.children?.length && <SubMenu items={item.children} />}
        </li>
    );
};
